export default __webpack_public_path__ + "static/media/info-circle-red.c216b2e5.svg";